export enum ScheduleRangeType {
  SINGLE = 'Single',
  MULTIPLE = 'Multiple',
}

export enum ScheduleDayType {
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
}

export enum ScheduleDayPartType {
  MORNING = 'Morning',
  AFTERNOON = 'Afternoon',
  EVENING = 'Evening',
}

export enum ScheduleConsultType {
  PHYSICAL = 'Physical',
  TELEPHONE = 'Telephone',
  VIDEO = 'Video',
}
